// Color schemes for layer visualization
// Used by Rectangle component and context menu layer info
export const LAYER_COLOR_SCHEMES = [
  '#FF6B6B', // red coral
  '#5C7CFA', // blue
  '#CC5DE8', // purple
  '#20C997', // teal
  '#FF922B', // orange
  '#845EF7', // violet blue
  '#F06595', // pink
  '#94D82D', // lime
  '#339AF0', // light blue
  '#ADB5BD', // gray
  '#FCC419', // yellow
  '#22B8CF', // cyan
  '#FF6F00', // deep orange
  '#51CF66', // green
  '#495057' // dark gray
]

export const getLayerColor = (index: number): string => {
  return LAYER_COLOR_SCHEMES[index % LAYER_COLOR_SCHEMES.length]
}
